<template>
  <div v-if="props.showMessage && resNotificationSent?.isConsentProvided"
       :class="[feedback.hasError ? 'app-alert-error' : 'app-alert-warning']"
       role="alert" aria-live="off"><!-- no feedback if user has opt-out -->
    <img v-if="feedback.hasError" src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <img v-else src="@ridmv/web-themes/images/icons/paper-plane-solid.svg" alt="">
    <p tabindex="-1" ref="message" class="animate__animated animate__headShake">
      {{ feedback.message }}
    </p>
  </div>
</template>

<script setup>
import _ from 'underscore';
import { computed, ref, watch, nextTick, onMounted } from 'vue';
import { useStore } from 'vuex';
import NotificationFeedback from '@/assets/data/_systemFeedback';

// Props 
const props = defineProps({
  showMessage: {
    type: Boolean,
    required: false,
    default: false,  // prevent display on reload
  },
});

// Vuex Store 
const store = useStore();

// State and Reactive Variables 
const feedback = ref({});
const message = ref(null); 

// Computed Properties
const resNotificationSent = computed(() => store.state.user.resNotificationSent);

// Watchers 
watch(resNotificationSent, () => {
  setupMessage();
});

// Methods
const getFeedback = () => {
  if (resNotificationSent.value.isConsentProvided) {
    const smsError = _.find(NotificationFeedback, fbk => fbk.errorType === 'sms');
    const emailError = _.find(NotificationFeedback, fbk => fbk.errorType === 'email');
    const dblError = _.find(NotificationFeedback, fbk => fbk.errorType === 'both');
    let feedback = _.find(NotificationFeedback, fbk => fbk.errorType === 'none');

    if (!resNotificationSent.value.isSmsSentSuccessfully && !resNotificationSent.value.isEmailSentSuccessfully) {
      feedback = dblError;
    } else if (!resNotificationSent.value.isSmsSentSuccessfully) {
      feedback = smsError;
    } else if (!resNotificationSent.value.isConsentProvided) {
      feedback = emailError;
    } else {
      // both phone + email sent okay
    }
    return { hasError: !(feedback.errorType === 'none'), message: feedback.message };
  }
  return {};
};

const setupMessage = async () => {
  feedback.value = getFeedback();
  await nextTick();
  if (resNotificationSent.value.isConsentProvided && message.value) {
    message.value.focus();
  }
};

// Lifecycle Hooks
onMounted(() => {
  setupMessage();
});
</script>


<style lang="scss" scoped>
@media print {
  div, img, p {
    display: none;
  }
}
</style>

